<ng-container *ngFor="let acreditacion of acreditacionesPayload; let i = index">
  <div class="content">
    <div class="actions">
      <button mat-raised-button color="primary" (click)="onEdit(acreditacionEmpresa[i].id)">Editar</button>
    </div>
    <rpe-entity-mis-empresas-datos-detail [dataOption]="acreditacion"></rpe-entity-mis-empresas-datos-detail>
  </div>
</ng-container>
